"use client";

import type { ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";

import { getQueryClient } from "../lib/queryClient";

export interface QueryProviderProps {
  children: ReactNode;
  /**
   * QueryClientProvider 안쪽을 한 번 더 감싸는 앱별 래퍼.
   * 예: JCG 의 ProblemCacheInvalidator — 앱 서버 액션으로 문제 캐시를 동기화하므로
   * 공용 패키지가 소유하면 빌드하는 앱과 무관하게 그 앱의 액션을 부르게 된다.
   */
  wrapper?: (children: ReactNode) => ReactNode;
  /** devtools 등 provider 하위에 함께 마운트할 노드. */
  extras?: ReactNode;
}

export default function QueryProvider({
  children,
  wrapper,
  extras,
}: QueryProviderProps) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      {wrapper ? wrapper(children) : children}
      {extras}
    </QueryClientProvider>
  );
}
